<template>
  <div class="flex w-20 items-center">
    <button
      type="button"
      :disabled="disableDecreaseButton || Number(number) === minNumber"
      :class="{
        '!bg-disabled': number === 0,
        '!hover:bg-hover': number === 0,
        '!text-gray-300': number === 0,
        '!border-gray-300': number === 0,
      }"
      class="bg-gray-white flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border-2 border-main-primary text-main-primary hover:bg-main-primary hover:text-white"
      @click="decrement"
    >
      -
    </button>
    <input
      type="text"
      class="w-20 flex-grow border border-none px-2 py-1 text-center focus:border-none focus:outline-none focus:ring-0"
      :value="number"
      @blur="$emit('blur')"
      @focusout="$emit('focusout', $event.target.value)"
      @input="$emit('input', $event.target.value)"
    >
    <button
      type="button"
      class="bg-gray-white flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border-2 border-main-primary text-main-primary hover:bg-main-primary hover:text-white"
      @click="increment"
    >
      <PlusSmall />
    </button>
  </div>
</template>

<script>
export default {
  name: 'NumberInput',

  props: {
    val: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      default: 1,
    },
    minNumber: {
      type: Number,
      default: 0,
    },
  },

  emits: ['input', 'valueUpdated', 'focusout', 'blur'],

  data() {
    return {
      number: this.val,
    }
  },
  computed: {
    disableDecreaseButton() {
      return this.weight < this.minNumber || this.weight === this.minNumber
    },
  },

  methods: {
    increment() {
      this.number = Number(Number(this.number) + this.step).toFixed(2)
      this.$emit('valueUpdated', this.number)
    },
    decrement() {
      if (this.number >= this.minNumber) {
        this.number = Number(Number(this.number) - this.step).toFixed(2)
        this.$emit('valueUpdated', this.number)
      }
    },
  },
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
